module.exports = __webpack_public_path__ + "img/Mask group green.e52719b9.svg";